import { useTranslations } from "@zapier/i18n";

import {
  Button,
  ModalDialogBody,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogRoot,
  Text,
} from "@zapier/design-system";

import { DateTime } from "@zapier/date-am";

interface Props {
  onClose: () => void;
  hasPaymentSource: boolean;
  teamsPlanPrice: number;
  onSubmit: () => void;
}

function TeamsTrialModal({
  onClose,
  hasPaymentSource,
  teamsPlanPrice,
  onSubmit,
}: Props) {
  const t = useTranslations("teams-trial-modal");

  const today = new Date();
  const twoWeeksFromToday = today.setDate(today.getDate() + 14);

  const title = hasPaymentSource
    ? t("titles.start-trial-to-continue")
    : t("titles.start-trial");

  // Waiting on Copy updates from Legal to finish this part
  const body = hasPaymentSource ? (
    <Text textAlign="center" color="GrayWarm9" type="Body1">
      {t.rich("billing.trial-end-warning", {
        teamsPlanPrice,
        date: () => <DateTime date={twoWeeksFromToday} />,
        bold: (chunks) => <strong>{chunks}</strong>,
        link: (chunks) => (
          <a target="_blank" href="/teams-companies">
            {chunks}
          </a>
        ),
      })}
    </Text>
  ) : (
    <Text textAlign="center" color="GrayWarm9" type="Body1">
      {t("descriptions.teams-benefits-trial-prompt")}
    </Text>
  );

  return (
    <ModalDialogRoot isOpen={true} onOpenChange={onClose}>
      <ModalDialogHeader textAlign="start">{title}</ModalDialogHeader>
      <ModalDialogBody textAlign="start">{body}</ModalDialogBody>
      <ModalDialogFooter>
        <Button variant="secondary" onPress={onClose} type="button">
          {t("buttons.cancel")}
        </Button>
        <Button variant="primary" onPress={onSubmit} type="button">
          {t("buttons.confirm")}
        </Button>
      </ModalDialogFooter>
    </ModalDialogRoot>
  );
}

export default TeamsTrialModal;
